import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from 'react-oidc-context';
import { QueryClientProvider } from '@tanstack/react-query';
import { oidcConfig } from '@/lib/auth/oidc';
import { queryClient } from '@/lib/queryClient';
import { ErrorBoundary } from '@/components/shell/ErrorBoundary';
import { ToastProvider } from '@/components/ui/toast';
import { ThemeProvider } from '@/components/theme/ThemeProvider';
import { AppRoutes } from '@/routes';

export function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <AuthProvider {...oidcConfig}>
            <ToastProvider>
              <BrowserRouter>
                <AppRoutes />
              </BrowserRouter>
            </ToastProvider>
          </AuthProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}
